import { useTranslation } from "react-i18next";

export type AuthMode = "mobile" | "email";
export type AuthStep = "input" | "otp";

export interface AuthUiStrings {
  heading: string;
  placeholder: string;
  inputType: "text" | "tel" | "email";
  inputMode:
    | "email"
    | "search"
    | "none"
    | "text"
    | "tel"
    | "url"
    | "numeric"
    | "decimal";
}

/**
 * React hook that returns UI strings and types for auth forms based on step and mode, using i18n keys.
 * @param step - current step (input | otp)
 * @param mode - current mode (mobile | email)
 */
export function useAuthUiStrings(
  step: AuthStep,
  mode: AuthMode
): AuthUiStrings {
  const { t } = useTranslation();
  if (step === "otp") {
    return {
      heading: t("auth.enterOtpHeading"),
      placeholder: t("auth.otpPlaceholder"),
      inputType: "text",
      inputMode: "numeric",
    };
  }
  if (mode === "mobile") {
    return {
      heading: t("auth.signupHeadingMob"),
      placeholder: t("auth.mobilePlaceholder"),
      inputType: "tel",
      inputMode: "numeric",
    };
  }
  return {
    heading: t("auth.signupHeading"),
    placeholder: t("auth.emailPlaceholder"),
    inputType: "email",
    inputMode: "email",
  };
}
